import {
  Home,
  Handshake,
  Compass,
  MessageCircle,
  Eye,
  Wallet,
  CalendarDays,
  BarChart3,
  GraduationCap,
  type LucideIcon,
} from 'lucide-react'

export type AthleteNavigationItem = {
  label: string
  path: string
  icon: LucideIcon
  end?: boolean
  showUnreadBadge?: boolean
  /** Shorter label for the phone tab bar, where five tabs share the width */
  shortLabel?: string
}

/** The five places an athlete goes: the bottom tab bar on phones, the header nav on desktop */
export const athleteTabs: AthleteNavigationItem[] = [
  { label: 'Home', path: '/', icon: Home, end: true },
  { label: 'Deals', path: '/deals', icon: Handshake },
  { label: 'Opportunities', shortLabel: 'Explore', path: '/opportunities', icon: Compass },
  { label: 'Messages', path: '/messages', icon: MessageCircle, showUnreadBadge: true },
  { label: 'My shop', path: '/brand-view', icon: Eye },
]

/** Everything else lives behind the avatar menu */
export const athleteMenuItems: AthleteNavigationItem[] = [
  { label: 'Earnings', path: '/earnings', icon: Wallet },
  { label: 'Content calendar', path: '/calendar', icon: CalendarDays },
  { label: 'Reporting', path: '/performance', icon: BarChart3 },
  { label: 'Academy', path: '/academy', icon: GraduationCap },
]

// Kept for the pages that still import the old name
export const athleteNavigationItems = [...athleteTabs, ...athleteMenuItems]
